import { render, staticRenderFns } from "./NameplateAutomation.vue?vue&type=template&id=72623ad8"
import script from "./NameplateAutomation.vue?vue&type=script&lang=js"
export * from "./NameplateAutomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports